import { resolveUrl } from '@wix/sdk-runtime/rest-modules';
import { ResolveUrlOpts } from '@wix/sdk-runtime/rest-modules';
import { RequestOptionsFactory } from '@wix/sdk-types';

function resolveComWixEcomCustomTriggerV1CustomTriggersServiceUrl(
  opts: Omit<ResolveUrlOpts, 'domainToMappings'>
) {
  const domainToMappings = {
    'api._api_base_domain_': [
      {
        srcPath: '/custom-triggers-service',
        destPath: '',
      },
    ],
    'www.wixapis.com': [
      {
        srcPath: '/ecom/v1/discount-custom-triggers',
        destPath: '/v1/discount-custom-triggers',
      },
    ],
    'manage._base_domain_': [
      {
        srcPath: '/ecom/v1/discount-custom-triggers',
        destPath: '/v1/discount-custom-triggers',
      },
      {
        srcPath: '/v1/discount-custom-triggers',
        destPath: '/v1/discount-custom-triggers',
      },
    ],
    '*.dev.wix-code.com': [
      {
        srcPath: '/_api/custom-triggers-service',
        destPath: '',
      },
    ],
    _: [
      {
        srcPath: '/_api/custom-triggers-service',
        destPath: '',
      },
    ],
  };

  return resolveUrl(Object.assign(opts, { domainToMappings }));
}

const PACKAGE_NAME = '@wix/auto_sdk_ecom_discounts-custom-trigger';

/** List all custom triggers that are available on a given site */
export function listTriggers(payload: object): RequestOptionsFactory<any> {
  function __listTriggers({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.ecom.custom_trigger.v1.custom_trigger',
      method: 'POST' as any,
      methodFqn:
        'com.wix.ecom.custom_trigger.v1.CustomTriggersService.ListTriggers',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveComWixEcomCustomTriggerV1CustomTriggersServiceUrl({
        protoPath: '/v1/discount-custom-triggers/list',
        data: payload,
        host,
      }),
      data: payload,
    };

    return metadata;
  }

  return __listTriggers;
}
